import 'es6-shim';
import 'promise.allsettled';
import 'core-js';

// Стили
import 'vue-toast-notification/dist/theme-default.css';
import '@/assets/style/main.scss';

import Core from "@/core/Core";

// Запускаем инициализацию
Core.initialize();
